/**
 * AIVA-6639 — AI disclaimer defaults. Since AIVA-8663 Studio configures these per
 * tenant (Platform Settings → Add-in Configuration) and they arrive on the add-in
 * settings payload; the values here apply only when the payload has no AI notice
 * (an older backend). See {@link resolveAiNoticePolicy} in ./policy.
 */
export const AI_NOTICE_CONFIG = {
  /** When false the first-run gate never shows. */
  requireAcknowledgement: true,
  /** How long an acknowledgement stays valid before the gate shows again. */
  ttlDays: 30,
} as const;

export const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const AI_NOTICE_TTL_MS = AI_NOTICE_CONFIG.ttlDays * MS_PER_DAY;
